import {
  AutopilotTaskDto,
  TaskCategoryTaskType,
} from '@urbanx/agx.activities.client'
import { TaskUpdatedNotification } from 'types/pushNotifications'

export interface TaskIdentity {
  campaignId?: string
  contractId?: string
  taskType?: TaskCategoryTaskType
}

type TaskIdentitySource = Pick<
  AutopilotTaskDto,
  'campaignId' | 'contractId' | 'category'
>
type TaskUpdateIdentitySource = Pick<
  TaskUpdatedNotification,
  'campaignId' | 'contractId' | 'taskType'
>

export const getTaskIdentity = (
  task?: TaskIdentitySource
): TaskIdentity => ({
  campaignId: task?.campaignId,
  contractId: task?.contractId,
  taskType: task?.category?.taskType,
})

export const getTaskUpdateIdentity = (
  taskUpdate?: TaskUpdateIdentitySource
): TaskIdentity => ({
  campaignId: taskUpdate?.campaignId,
  contractId: taskUpdate?.contractId,
  taskType: taskUpdate?.taskType,
})

export const areTaskIdentitiesEqual = (
  left?: TaskIdentity,
  right?: TaskIdentity
): boolean =>
  left?.campaignId === right?.campaignId &&
  left?.contractId === right?.contractId &&
  left?.taskType === right?.taskType

export const isSameTask = (
  task: TaskIdentitySource,
  candidate: TaskIdentitySource
) => areTaskIdentitiesEqual(getTaskIdentity(task), getTaskIdentity(candidate))

export const doesTaskMatchUpdate = (
  task: TaskIdentitySource,
  taskUpdate: TaskUpdateIdentitySource
) =>
  areTaskIdentitiesEqual(getTaskIdentity(task), getTaskUpdateIdentity(taskUpdate))
